<template>
  <div class="zj-emergency-task-process">
    <el-tabs class="custom-tabs" v-model="activeName">
      <el-tab-pane label="应急任务" name="first">
        <task-list v-bind:tableData="tableData" v-bind:planName="planName" v-bind:planId="planId" />
      </el-tab-pane>
      <el-tab-pane label="应急反馈" name="second">
        <task-feedback-list v-bind:ExecutId="ExecutId" />
      </el-tab-pane>
      <el-tab-pane label="人员调度" name="third">
        <PersonSchedule :roomId="roomId" :pwd="pwd" v-bind:ExecutId="ExecutId"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import TaskList from "./Component-TaskList";
import TaskFeedbackList from "./Component-TaskFeedbackList";
import PersonSchedule from './Component-PersonSchedule'

export default {
  name: "ZJEmergencyComponentTaskProcess",
  componentName: "ZJEmergencyComponentTaskProcess",
  components: {
    "task-list": TaskList,
    "task-feedback-list": TaskFeedbackList,
    "PersonSchedule":PersonSchedule
  },
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    tableData: {
      type: Object,
      default: function() {
        return [];
      }
    },
    planName: String,
    planId: String,
    roomId: {
      type: String
    },
    pwd: {
      type: String
    }
  },
  data() {
    return {
      activeName: "first"
    };
  }
};
</script>